// src/pages/About.js
import React from 'react';
import Header from './components/Header';
import Lottie from 'lottie-react';
import frustrated from './jsons/frustrated.json';
import taken from './jsons/taken.json';
import forgot from './jsons/forgot.json';
import schedule from './jsons/schedule.json';
import wonder from './jsons/wonder.json';
import mother from './jsons/mother.json'; // Note: changed from schedule.json to schedule2.json
import coms from './jsons/coms.json'; // Note: changed from schedule.json to schedule2.json
import { useNavigate } from 'react-router-dom';

import './About.css';

const About = () => {
  const navigate = useNavigate();

  return (
    <div className="about-page">
      <Header />

      <main className="about-main">
        {/* Hero Section */}
        <div className="about-hero">
          <h1 className="hero-title">
            MedTracker
            {/* <span className="hero-badge">Beta</span> */}
          </h1>
          <p className="hero-subtitle">
Track your medications and never miss a dose.
          </p>
      
<div className="hero-cta">
  <button className="cta-button primary" onClick={() => navigate('/support')}>
    Contact Us <i>✉️</i>
  </button>
  <button className="cta-button secondary">
    Watch Demo <i>▶</i>
  </button>
</div>
        </div>

        {/* Why You Need MedTracker */}
        <section className="about-section">
          <h2>Why You Need MedTracker</h2>
          {/* <p className="section-subtitle">
            Busy lives. Important medications. Here's how MedTracker turns common struggles into effortless habits.
          </p> */}

          <div className="why-cards">

{/* Card 1 */}
<div className="why-card">
  <div className="card-number">1</div>
  <div className="problem-solution-grid">
    <div className="problem-side">
      <h3 className="problem-text">Do you forget to take your medicine?</h3>
      <div className="lottie-wrapper">
        <div className="lottie-container">
          <Lottie 
            animationData={frustrated} 
            loop 
            autoplay 
            className="lottie-icon"
          />
        </div>
      </div>
    </div>
    <div className="solution-side">
      <h3>With MedTracker</h3>
      <div className="lottie-wrapper">
        <div className="lottie-container">
          <Lottie 
            animationData={taken} 
            loop 
            autoplay 
            className="lottie-icon"
          />
        </div>
      </div>
      <h3 className="solution-text">Receive notifications that remind you.</h3>
    </div>
  </div>
</div>

{/* Card 2 */}
<div className="why-card">
  <div className="card-number">2</div>
  <div className="problem-solution-grid">
    <div className="problem-side">
      <h3>Do you forget your Meds schedule?</h3>
      <div className="lottie-wrapper">
        <div className="lottie-container">
          <Lottie 
            animationData={forgot} 
            loop 
            autoplay 
            className="lottie-icon"
          />
        </div>
      </div>
    </div>
    <div className="solution-side">
      <h3>But With MedTracker</h3>
      <div className="lottie-wrapper">
        <div className="lottie-container">
          <Lottie 
            animationData={schedule} 
            loop 
            autoplay 
            className="lottie-icon"
          />
        </div>
      </div>
      <p className="solution-text">Easily track every dose — never miss again.</p>
    </div>
  </div>
</div>

{/* Card 3 */}
<div className="why-card">
  <div className="card-number">3</div>
  <div className="problem-solution-grid">
    <div className="problem-side">
      <h3>Need to monitor a loved one's medication?</h3>
      <div className="lottie-wrapper">
        <div className="lottie-container">
          <Lottie 
            animationData={mother} 
            loop 
            autoplay 
            className="lottie-icon"
          />
        </div>
      </div>
    </div>
    <div className="solution-side">
      <h3>With MedTracker</h3>
      <div className="lottie-wrapper">
        <div className="lottie-container">
          <Lottie 
            animationData={coms} 
            loop 
            autoplay 
            className="lottie-icon"
          />
        </div>
      </div>
      <p className="solution-text">Share schedules and track in real time.</p>
    </div>
  </div>
</div>
          </div>
        </section>

        {/* Mission Section */}
        <section className="about-section mission">
          <h2>Our Mission</h2>
          <div className="mission-content">
            <p>
              We created MedTracker because missing a dose should never happen by accident.  
              Our mission is to make medication management simple, reliable, and completely stress-free — 
              so you can focus on living your life.
            </p>
          </div>
        </section>

        {/* Features Section - What We Do (Green) */}
        <section className="about-section features">
          <h2>✨ What MedTracker Does</h2>
          <div className="features-grid">
            <div className="feature-item positive">
              <span className="feature-emoji">💊</span>
              <div className="feature-text">
                <h4>Multi-Med Tracking</h4>
                <p>Track multiple medications & dosages</p>
              </div>
            </div>
            <div className="feature-item positive">
              <span className="feature-emoji">⏰</span>
              <div className="feature-text">
                <h4>Smart Reminders</h4>
                <p>Customizable alerts before it's time</p>
              </div>
            </div>
            <div className="feature-item positive">
              <span className="feature-emoji">📊</span>
              <div className="feature-text">
                <h4>Analytics Dashboard</h4>
                <p>Clear history & adherence insights</p>
              </div>
            </div>
            <div className="feature-item positive">
              <span className="feature-emoji">🔔</span>
              <div className="feature-text">
                <h4>Push Notifications</h4>
                <p>Reliable alerts across all devices</p>
              </div>
            </div>
            <div className="feature-item positive">
              <span className="feature-emoji">📱</span>
              <div className="feature-text">
                <h4>Cross-Platform</h4>
                <p>Beautiful on phone, tablet & web</p>
              </div>
            </div>
            <div className="feature-item positive">
              <span className="feature-emoji">🔒</span>
              <div className="feature-text">
                <h4>Privacy First</h4>
                <p>Your data stays private & secure</p>
              </div>
            </div>
          </div>
        </section>

        {/* Limitations Section - What We DON'T Do (Red) */}
        <section className="about-section limitations">
          <h2>⚠️ What MedTracker Doesn't Do</h2>
          <p className="section-subtitle">
            We're here to help you track, not to replace professional medical advice.
          </p>
          
          <div className="limitations-grid">
            <div className="limitation-item">
              <div className="limitation-icon">🚫</div>
              <div className="limitation-content">
                <h4>No Medical Advice</h4>
                <p>We don't provide medical advice, diagnoses, or treatment recommendations.</p>
              </div>
            </div>
            
            <div className="limitation-item">
              <div className="limitation-icon">💊</div>
              <div className="limitation-content">
                <h4>No Prescription Modifications</h4>
                <p>We never modify, suggest, or adjust your prescriptions. Always follow your doctor's instructions.</p>
              </div>
            </div>
            
            <div className="limitation-item">
              <div className="limitation-icon">👨‍⚕️</div>
              <div className="limitation-content">
                <h4>Not a Healthcare Professional</h4>
                <p>MedTracker is a tracking tool, not a replacement for professional healthcare providers.</p>
              </div>
            </div>
          </div>
          
          <div className="disclaimer-box">
            <p className="disclaimer-text">
              <strong>Important:</strong> Always consult with your healthcare provider before making any changes to your medication routine. MedTracker is designed to help you remember and track, but your doctor knows what's best for your health.
            </p>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="about-footer">
        {/* <div className="footer-links">
          <a href="/privacy">Privacy Policy</a>
          <a href="/terms">Terms of Service</a>
          <a href="/contact">Contact Us</a>
          <a href="/faq">FAQ</a>
        </div> */}
        <div className="copyright">
          © {new Date().getFullYear()} MedTracker. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default About;